import { ActiveSenderOfferName, REFERRAL_SENDER_OFFER_LOOKUP } from './data';

export const getReferralSenderOffer = (offerName: ActiveSenderOfferName) => {
  return REFERRAL_SENDER_OFFER_LOOKUP[offerName];
};
